import { useStyles } from './RecipentStakeholderRow.styles'

export const RecipentStakeholderRow = ({
  title,
  value,
  keyName,
  description,
}: {
  title?: string | JSX.Element
  value?: string | JSX.Element
  keyName?: string
  description?: string | JSX.Element
}) => {
  const { classes } = useStyles({ title })
  return (
    <div className={classes.root}>
      {title && (
        <div className={classes.title} data-testid={`${keyName}-key`}>
          {title}
        </div>
      )}
      {value && (
        <div className={classes.value} data-testid={`${keyName}-value`}>
          {value}
        </div>
      )}
      {description && (
        <div
          className={classes.description}
          data-testid={`${keyName}-description`}
        >
          {description}
        </div>
      )}
    </div>
  )
}
